import React from "react";
import { Panel } from "../ui";

const pct = (n, d) => (d ? `${Math.round((n / d) * 100)}%` : "-");

/** Delivered / opened / clicked / bounced / complained for one mailout. */
export function CampaignTracking({ tracking, trackingConfigured, sent }) {
  const t = tracking || {};
  const base = t.delivered || t.recorded || sent || 0;
  const cells = [
    ["Delivered", t.delivered || 0, pct(t.delivered || 0, t.recorded || sent), "delivered"],
    ["Opened", t.opened || 0, pct(t.opened || 0, base), "opened"],
    ["Clicked", t.clicked || 0, pct(t.clicked || 0, base), "clicked"],
    ["Bounced", t.bounced || 0, pct(t.bounced || 0, t.recorded || sent), "bounced"],
    ["Spam reports", t.complained || 0, pct(t.complained || 0, t.recorded || sent), "complained"],
  ];
  return (
    <Panel>
      <p className="text-xs font-semibold uppercase tracking-wider gold-text">How it went</p>
      {!trackingConfigured && (
        <p className="mt-2 text-[11px] leading-relaxed text-[color:var(--nq-stone)]" data-testid="tracking-not-configured">
          Open and bounce tracking turns on once the Resend webhook is connected.
        </p>
      )}
      <div className="mt-3 grid grid-cols-2 gap-3 sm:grid-cols-5" data-testid="campaign-tracking">
        {cells.map(([label, n, rate, key]) => (
          <div key={key} data-testid={`tracking-${key}`}>
            <p className="text-lg font-semibold">{n}</p>
            <p className="text-[11px] text-[color:var(--nq-stone)]">{label} · {rate}</p>
          </div>
        ))}
      </div>
      <p className="mt-3 text-[11px] leading-relaxed text-[color:var(--nq-stone)]">
        Bounced and spam-report addresses are taken off the list automatically. Apple Mail opens
        emails for people, so open rates read high - clicks are the honest number.
      </p>
    </Panel>
  );
}
